import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-short-text-icon',
},
  __name: 'text-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: __props.fill
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      _createElementVNode("path", { d: "M5 9h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h8c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z" }, null, -1)
    ]))], 8, _hoisted_2))
  ]))
}
}

})